/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './payroll-time.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/forms';
import * as import3 from '@angular/common';
import * as import4 from '../../../../app/booking-management/payroll-time/payroll-time.component';
const styles_PayrollTimeComponent:any[] = [import0.styles];
export const RenderType_PayrollTimeComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_PayrollTimeComponent,
  data: {}
}
);
function View_PayrollTimeComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollTimeComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollTimeComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollTimeComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollTimeComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollTimeComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Inter. time NG*'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'id',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,8)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,8).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,8)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,8)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.interpreting_time_night = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'interTimeNG',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollTimeComponent_6)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_11:any = '(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,9,0,currVal_11);
    const currVal_12:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interTimeNG_') + co.index),'');
    const currVal_13:any = co.payrollInvoice.interpreting_time_night;
    ck(v,12,0,currVal_12,currVal_13);
    const currVal_14:any = (import1.ɵnov(v,12).touched && ((import1.ɵnov(v,12).errors == null)? (null as any): import1.ɵnov(v,12).errors.pattern));
    ck(v,17,0,currVal_14);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.isReadOnly;
    const currVal_1:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interTimeNG_') + co.index),'');
    const currVal_2:any = co.travelTimePlaceHolder;
    const currVal_3:any = (import1.ɵnov(v,9).pattern? import1.ɵnov(v,9).pattern: (null as any));
    const currVal_4:any = import1.ɵnov(v,14).ngClassUntouched;
    const currVal_5:any = import1.ɵnov(v,14).ngClassTouched;
    const currVal_6:any = import1.ɵnov(v,14).ngClassPristine;
    const currVal_7:any = import1.ɵnov(v,14).ngClassDirty;
    const currVal_8:any = import1.ɵnov(v,14).ngClassValid;
    const currVal_9:any = import1.ɵnov(v,14).ngClassInvalid;
    const currVal_10:any = import1.ɵnov(v,14).ngClassPending;
    ck(v,7,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10
    ]
    );
  });
}
function View_PayrollTimeComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollTimeComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Inter. time WKN*'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'id',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,8)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,8).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,8)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,8)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.interpreting_time_weekend = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'interTimeWKN',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollTimeComponent_8)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_11:any = '(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,9,0,currVal_11);
    const currVal_12:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interTimeWKN_') + co.index),'');
    const currVal_13:any = co.payrollInvoice.interpreting_time_weekend;
    ck(v,12,0,currVal_12,currVal_13);
    const currVal_14:any = (import1.ɵnov(v,12).touched && ((import1.ɵnov(v,12).errors == null)? (null as any): import1.ɵnov(v,12).errors.pattern));
    ck(v,17,0,currVal_14);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.isReadOnly;
    const currVal_1:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interTimeWKN_') + co.index),'');
    const currVal_2:any = co.travelTimePlaceHolder;
    const currVal_3:any = (import1.ɵnov(v,9).pattern? import1.ɵnov(v,9).pattern: (null as any));
    const currVal_4:any = import1.ɵnov(v,14).ngClassUntouched;
    const currVal_5:any = import1.ɵnov(v,14).ngClassTouched;
    const currVal_6:any = import1.ɵnov(v,14).ngClassPristine;
    const currVal_7:any = import1.ɵnov(v,14).ngClassDirty;
    const currVal_8:any = import1.ɵnov(v,14).ngClassValid;
    const currVal_9:any = import1.ɵnov(v,14).ngClassInvalid;
    const currVal_10:any = import1.ɵnov(v,14).ngClassPending;
    ck(v,7,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10
    ]
    );
  });
}
export function View_PayrollTimeComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(402653184,1,{form: 0}),
    (l()(),import1.ɵeld(0,(null as any),(null as any),101,'form',[
      [
        'ngForm',
        'payrollTimeFields'
      ]
      ,
      [
        'novalidate',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,3).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,3).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.ɵbf,([] as any[]),(null as any),(null as any)),
    import1.ɵdid(16384,[
      [
        1,
        4
      ]
      ,
      [
        'payrollTimeFields',
        4
      ]

    ]
    ,0,import2.NgForm,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(2048,(null as any),import2.ControlContainer,(null as any),[import2.NgForm]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatusGroup,[import2.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),85,'footer',[[
        'class',
        'payroll-card__footer common-form'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Inter. time*'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.PayrollTimeComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,17)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,17).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,17)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,17)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.interpreting_time = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'interpreterTime',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollTimeComponent_1)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Prep. time'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.PayrollTimeComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,38)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,38).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,38)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,38)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.preparation_time = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'prepTime',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollTimeComponent_2)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['KM*'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.PayrollTimeComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,59)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,59).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,59)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,59)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.distance = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'kiloMeters',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollTimeComponent_3)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Travel time*'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.PayrollTimeComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,80)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,80).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,80)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,80)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.travel_time = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'travelTime',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollTimeComponent_4)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'footer',[[
        'class',
        'payroll-card__footer common-form'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollTimeComponent_5)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollTimeComponent_7)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.PayrollTimeComponent = v.component;
    const currVal_17:any = '(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,18,0,currVal_17);
    const currVal_18:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interpreterTime_') + co.index),'');
    const currVal_19:any = co.payrollInvoice.interpreting_time;
    ck(v,21,0,currVal_18,currVal_19);
    const currVal_20:any = (import1.ɵnov(v,21).touched && ((import1.ɵnov(v,21).errors == null)? (null as any): import1.ɵnov(v,21).errors.pattern));
    ck(v,26,0,currVal_20);
    const currVal_31:any = '(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,39,0,currVal_31);
    const currVal_32:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'prepTime_') + co.index),'');
    const currVal_33:any = co.payrollInvoice.preparation_time;
    ck(v,42,0,currVal_32,currVal_33);
    const currVal_34:any = (import1.ɵnov(v,42).touched && ((import1.ɵnov(v,42).errors == null)? (null as any): import1.ɵnov(v,42).errors.pattern));
    ck(v,47,0,currVal_34);
    const currVal_45:any = '(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,60,0,currVal_45);
    const currVal_46:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'kiloMeters_') + co.index),'');
    const currVal_47:any = co.payrollInvoice.distance;
    ck(v,63,0,currVal_46,currVal_47);
    const currVal_48:any = (import1.ɵnov(v,63).touched && ((import1.ɵnov(v,63).errors == null)? (null as any): import1.ɵnov(v,63).errors.pattern));
    ck(v,68,0,currVal_48);
    const currVal_59:any = '(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,81,0,currVal_59);
    const currVal_60:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'travelTime_') + co.index),'');
    const currVal_61:any = co.payrollInvoice.travel_time;
    ck(v,84,0,currVal_60,currVal_61);
    const currVal_62:any = (import1.ɵnov(v,84).touched && ((import1.ɵnov(v,84).errors == null)? (null as any): import1.ɵnov(v,84).errors.pattern));
    ck(v,89,0,currVal_62);
    const currVal_63:any = co.isNG;
    ck(v,97,0,currVal_63);
    const currVal_64:any = co.isWKN;
    ck(v,100,0,currVal_64);
  },(ck,v) => {
    var co:import4.PayrollTimeComponent = v.component;
    const currVal_0:any = import1.ɵnov(v,5).ngClassUntouched;
    const currVal_1:any = import1.ɵnov(v,5).ngClassTouched;
    const currVal_2:any = import1.ɵnov(v,5).ngClassPristine;
    const currVal_3:any = import1.ɵnov(v,5).ngClassDirty;
    const currVal_4:any = import1.ɵnov(v,5).ngClassValid;
    const currVal_5:any = import1.ɵnov(v,5).ngClassInvalid;
    const currVal_6:any = import1.ɵnov(v,5).ngClassPending;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_7:any = co.isReadOnly;
    const currVal_8:any = co.interpTimePlaceHolder;
    const currVal_9:any = (import1.ɵnov(v,18).pattern? import1.ɵnov(v,18).pattern: (null as any));
    const currVal_10:any = import1.ɵnov(v,23).ngClassUntouched;
    const currVal_11:any = import1.ɵnov(v,23).ngClassTouched;
    const currVal_12:any = import1.ɵnov(v,23).ngClassPristine;
    const currVal_13:any = import1.ɵnov(v,23).ngClassDirty;
    const currVal_14:any = import1.ɵnov(v,23).ngClassValid;
    const currVal_15:any = import1.ɵnov(v,23).ngClassInvalid;
    const currVal_16:any = import1.ɵnov(v,23).ngClassPending;
    ck(v,16,0,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16);
    const currVal_21:any = co.isReadOnly;
    const currVal_22:any = co.prepTimePlaceHolder;
    const currVal_23:any = (import1.ɵnov(v,39).pattern? import1.ɵnov(v,39).pattern: (null as any));
    const currVal_24:any = import1.ɵnov(v,44).ngClassUntouched;
    const currVal_25:any = import1.ɵnov(v,44).ngClassTouched;
    const currVal_26:any = import1.ɵnov(v,44).ngClassPristine;
    const currVal_27:any = import1.ɵnov(v,44).ngClassDirty;
    const currVal_28:any = import1.ɵnov(v,44).ngClassValid;
    const currVal_29:any = import1.ɵnov(v,44).ngClassInvalid;
    const currVal_30:any = import1.ɵnov(v,44).ngClassPending;
    ck(v,37,0,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30);
    const currVal_35:any = co.isReadOnly;
    const currVal_36:any = co.kmPlaceHolder;
    const currVal_37:any = (import1.ɵnov(v,60).pattern? import1.ɵnov(v,60).pattern: (null as any));
    const currVal_38:any = import1.ɵnov(v,65).ngClassUntouched;
    const currVal_39:any = import1.ɵnov(v,65).ngClassTouched;
    const currVal_40:any = import1.ɵnov(v,65).ngClassPristine;
    const currVal_41:any = import1.ɵnov(v,65).ngClassDirty;
    const currVal_42:any = import1.ɵnov(v,65).ngClassValid;
    const currVal_43:any = import1.ɵnov(v,65).ngClassInvalid;
    const currVal_44:any = import1.ɵnov(v,65).ngClassPending;
    ck(v,58,0,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44);
    const currVal_49:any = co.isReadOnly;
    const currVal_50:any = co.travelTimePlaceHolder;
    const currVal_51:any = (import1.ɵnov(v,81).pattern? import1.ɵnov(v,81).pattern: (null as any));
    const currVal_52:any = import1.ɵnov(v,86).ngClassUntouched;
    const currVal_53:any = import1.ɵnov(v,86).ngClassTouched;
    const currVal_54:any = import1.ɵnov(v,86).ngClassPristine;
    const currVal_55:any = import1.ɵnov(v,86).ngClassDirty;
    const currVal_56:any = import1.ɵnov(v,86).ngClassValid;
    const currVal_57:any = import1.ɵnov(v,86).ngClassInvalid;
    const currVal_58:any = import1.ɵnov(v,86).ngClassPending;
    ck(v,79,0,currVal_49,currVal_50,currVal_51,currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58);
  });
}
function View_PayrollTimeComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-payroll-time',([] as any[]),(null as any),(null as any),(null as any),View_PayrollTimeComponent_0,RenderType_PayrollTimeComponent)),
    import1.ɵdid(4308992,(null as any),0,import4.PayrollTimeComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PayrollTimeComponentNgFactory:import1.ComponentFactory<import4.PayrollTimeComponent> = import1.ɵccf('app-payroll-time',import4.PayrollTimeComponent,View_PayrollTimeComponent_Host_0,{
  payrollInvoice: 'payrollInvoice',
  index: 'index',
  isClient: 'isClient',
  parentForm: 'parentForm',
  isReadOnly: 'isReadOnly'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvcGF5cm9sbC10aW1lL3BheXJvbGwtdGltZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL2Jvb2tpbmctbWFuYWdlbWVudC9wYXlyb2xsLXRpbWUvcGF5cm9sbC10aW1lLmNvbXBvbmVudC50cyIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvcGF5cm9sbC10aW1lL3BheXJvbGwtdGltZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvcGF5cm9sbC10aW1lL3BheXJvbGwtdGltZS5jb21wb25lbnQudHMuUGF5cm9sbFRpbWVDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8Zm9ybSAgbmdGb3JtPVwicGF5cm9sbFRpbWVGaWVsZHNcIiAjcGF5cm9sbFRpbWVGaWVsZHM9XCJuZ0Zvcm1cIj5cbiAgICA8Zm9vdGVyIGNsYXNzPVwicGF5cm9sbC1jYXJkX19mb290ZXIgY29tbW9uLWZvcm1cIj5cbiAgICAgICAgPGRpdiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZVwiPlxuICAgICAgICAgICAgPHNwYW4gY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtbmFtZVwiPkludGVyLiB0aW1lKjwvc3Bhbj5cbiAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJmb3JtLWZpZWxkXCI+XG4gICAgICAgICAgICAgICAgPGlucHV0IHR5cGU9XCJ0ZXh0XCIgbmFtZT1cInt7KGlzQ2xpZW50ID8gJ2NsaWVudF8nIDogJ2ludGVycHJldGVyXycpICsgJ2ludGVycHJldGVyVGltZV8nICsgaW5kZXh9fVwiICNpbnRlcnByZXRlclRpbWU9XCJuZ01vZGVsXCIgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgICAgICBbcGxhY2Vob2xkZXJdPVwiaW50ZXJwVGltZVBsYWNlSG9sZGVyXCIgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtaW5wdXRcIiBbKG5nTW9kZWwpXT1cInBheXJvbGxJbnZvaWNlLmludGVycHJldGluZ190aW1lXCIgcGF0dGVybj1cIihcXGQrfFxcZCsoXFwufFxcOilcXGQrKVwiPlxuICAgICAgICAgICAgICAgIDxzcGFuICpuZ0lmPVwiaW50ZXJwcmV0ZXJUaW1lLnRvdWNoZWQgJiYgKGludGVycHJldGVyVGltZS5lcnJvcnM/LnBhdHRlcm4pO1wiXG4gICAgICAgICAgICAgICAgICAgIGNsYXNzPVwiaW5saW5lLWljb24gZXJyb3JcIj5cbiAgICAgICAgICAgICAgICAgICAgPHNwYW4+T29wcyEgT25seSBudW1lcmljYWwgdmFsdWVzLCBcIi5cIiBhbmQgXCI6XCIgYXJlIGFsbG93ZWQuPC9zcGFuPiFcbiAgICAgICAgICAgICAgICA8L3NwYW4+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmVcIj5cbiAgICAgICAgICAgIDxzcGFuIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLW5hbWVcIj5QcmVwLiB0aW1lPC9zcGFuPlxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIiBuYW1lPVwie3soaXNDbGllbnQgPyAnY2xpZW50XycgOiAnaW50ZXJwcmV0ZXJfJykgKyAncHJlcFRpbWVfJyArIGluZGV4fX1cIiAjcHJlcFRpbWU9XCJuZ01vZGVsXCIgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgICAgICBbcGxhY2Vob2xkZXJdPVwicHJlcFRpbWVQbGFjZUhvbGRlclwiIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLWlucHV0XCIgWyhuZ01vZGVsKV09XCJwYXlyb2xsSW52b2ljZS5wcmVwYXJhdGlvbl90aW1lXCIgcGF0dGVybj1cIihcXGQrfFxcZCsoXFwufFxcOilcXGQrKVwiPlxuICAgICAgICAgICAgICAgIDxzcGFuICpuZ0lmPVwicHJlcFRpbWUudG91Y2hlZCAmJiAocHJlcFRpbWUuZXJyb3JzPy5wYXR0ZXJuKTtcIlxuICAgICAgICAgICAgICAgICAgICBjbGFzcz1cImlubGluZS1pY29uIGVycm9yXCI+XG4gICAgICAgICAgICAgICAgICAgIDxzcGFuPk9vcHMhIE9ubHkgbnVtZXJpY2FsIHZhbHVlcywgXCIuXCIgYW5kIFwiOlwiIGFyZSBhbGxvd2VkLjwvc3Bhbj4hXG4gICAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvZGl2PlxuICAgICAgICA8ZGl2IGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlXCI+XG4gICAgICAgICAgICA8c3BhbiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1uYW1lXCI+S00qPC9zcGFuPlxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIiBuYW1lPVwie3soaXNDbGllbnQgPyAnY2xpZW50XycgOiAnaW50ZXJwcmV0ZXJfJykgKyAna2lsb01ldGVyc18nICsgaW5kZXh9fVwiICNraWxvTWV0ZXJzPVwibmdNb2RlbFwiIFtyZWFkb25seV09XCJpc1JlYWRPbmx5XCJcbiAgICAgICAgICAgICAgICAgICAgW3BsYWNlaG9sZGVyXT1cImttUGxhY2VIb2xkZXJcIiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1pbnB1dFwiIFsobmdNb2RlbCldPVwicGF5cm9sbEludm9pY2UuZGlzdGFuY2VcIiBwYXR0ZXJuPVwiKFxcZCt8XFxkKyhcXC58XFw6KVxcZCspXCI+XG4gICAgICAgICAgICAgICAgPHNwYW4gKm5nSWY9XCJraWxvTWV0ZXJzLnRvdWNoZWQgJiYgKGtpbG9NZXRlcnMuZXJyb3JzPy5wYXR0ZXJuKTtcIlxuICAgICAgICAgICAgICAgICAgICBjbGFzcz1cImlubGluZS1pY29uIGVycm9yXCI+XG4gICAgICAgICAgICAgICAgICAgIDxzcGFuPk9vcHMhIE9ubHkgbnVtZXJpY2FsIHZhbHVlcywgXCIuXCIgYW5kIFwiOlwiIGFyZSBhbGxvd2VkLjwvc3Bhbj4hXG4gICAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvZGl2PlxuICAgICAgICA8ZGl2IGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlXCI+XG4gICAgICAgICAgICA8c3BhbiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1uYW1lXCI+VHJhdmVsIHRpbWUqPC9zcGFuPlxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIiBuYW1lPVwie3soaXNDbGllbnQgPyAnY2xpZW50XycgOiAnaW50ZXJwcmV0ZXJfJykgKyAndHJhdmVsVGltZV8nICsgaW5kZXh9fVwiICN0cmF2ZWxUaW1lPVwibmdNb2RlbFwiIFtyZWFkb25seV09XCJpc1JlYWRPbmx5XCJcbiAgICAgICAgICAgICAgICAgICAgW3BsYWNlaG9sZGVyXT1cInRyYXZlbFRpbWVQbGFjZUhvbGRlclwiIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLWlucHV0XCIgWyhuZ01vZGVsKV09XCJwYXlyb2xsSW52b2ljZS50cmF2ZWxfdGltZVwiIHBhdHRlcm49XCIoXFxkK3xcXGQrKFxcLnxcXDopXFxkKylcIj5cbiAgICAgICAgICAgICAgICA8c3BhbiAqbmdJZj1cInRyYXZlbFRpbWUudG91Y2hlZCAmJiAodHJhdmVsVGltZS5lcnJvcnM/LnBhdHRlcm4pO1wiXG4gICAgICAgICAgICAgICAgICAgIGNsYXNzPVwiaW5saW5lLWljb24gZXJyb3JcIj5cbiAgICAgICAgICAgICAgICAgICAgPHNwYW4+T29wcyEgT25seSBudW1lcmljYWwgdmFsdWVzLCBcIi5cIiBhbmQgXCI6XCIgYXJlIGFsbG93ZWQuPC9zcGFuPiFcbiAgICAgICAgICAgICAgICA8L3NwYW4+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgPC9kaXY+XG4gICAgPC9mb290ZXI+XG4gICAgPGZvb3RlciBjbGFzcz1cInBheXJvbGwtY2FyZF9fZm9vdGVyIGNvbW1vbi1mb3JtXCI+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmVcIiAqbmdJZj0naXNORyc+XG4gICAgICAgICAgICA8c3BhbiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1uYW1lXCI+SW50ZXIuIHRpbWUgTkcqPC9zcGFuPlxuICAgICAgICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIiBuYW1lPVwie3soaXNDbGllbnQgPyAnY2xpZW50XycgOiAnaW50ZXJwcmV0ZXJfJykgKyAnaW50ZXJUaW1lTkdfJyArIGluZGV4fX1cIiAjaW50ZXJUaW1lTkc9XCJuZ01vZGVsXCIgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgICAgICBpZD1cInt7KGlzQ2xpZW50ID8gJ2NsaWVudF8nIDogJ2ludGVycHJldGVyXycpICsgJ2ludGVyVGltZU5HXycgKyBpbmRleH19XCJcbiAgICAgICAgICAgICAgICAgICAgW3BsYWNlaG9sZGVyXT1cInRyYXZlbFRpbWVQbGFjZUhvbGRlclwiIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLWlucHV0XCIgWyhuZ01vZGVsKV09XCJwYXlyb2xsSW52b2ljZS5pbnRlcnByZXRpbmdfdGltZV9uaWdodFwiIHBhdHRlcm49XCIoXFxkK3xcXGQrKFxcLnxcXDopXFxkKylcIj5cbiAgICAgICAgICAgICAgICA8c3BhbiAqbmdJZj1cImludGVyVGltZU5HLnRvdWNoZWQgJiYgKGludGVyVGltZU5HLmVycm9ycz8ucGF0dGVybik7XCJcbiAgICAgICAgICAgICAgICAgICAgY2xhc3M9XCJpbmxpbmUtaWNvbiBlcnJvclwiPlxuICAgICAgICAgICAgICAgICAgICA8c3Bhbj5Pb3BzISBPbmx5IG51bWVyaWNhbCB2YWx1ZXMsIFwiLlwiIGFuZCBcIjpcIiBhcmUgYWxsb3dlZC48L3NwYW4+IVxuICAgICAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZVwiICpuZ0lmPSdpc1dLTic+XG4gICAgICAgICAgICA8c3BhbiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1uYW1lXCI+SW50ZXIuIHRpbWUgV0tOKjwvc3Bhbj5cbiAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJmb3JtLWZpZWxkXCI+XG4gICAgICAgICAgICAgICAgPGlucHV0IHR5cGU9XCJ0ZXh0XCIgbmFtZT1cInt7KGlzQ2xpZW50ID8gJ2NsaWVudF8nIDogJ2ludGVycHJldGVyXycpICsgJ2ludGVyVGltZVdLTl8nICsgaW5kZXh9fVwiICNpbnRlclRpbWVXS049XCJuZ01vZGVsXCIgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgICAgICBpZD1cInt7KGlzQ2xpZW50ID8gJ2NsaWVudF8nIDogJ2ludGVycHJldGVyXycpICsgJ2ludGVyVGltZVdLTl8nICsgaW5kZXh9fVwiXG4gICAgICAgICAgICAgICAgICAgIFtwbGFjZWhvbGRlcl09XCJ0cmF2ZWxUaW1lUGxhY2VIb2xkZXJcIiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1pbnB1dFwiIFsobmdNb2RlbCldPVwicGF5cm9sbEludm9pY2UuaW50ZXJwcmV0aW5nX3RpbWVfd2Vla2VuZFwiIHBhdHRlcm49XCIoXFxkK3xcXGQrKFxcLnxcXDopXFxkKylcIj5cbiAgICAgICAgICAgICAgICA8c3BhbiAqbmdJZj1cImludGVyVGltZVdLTi50b3VjaGVkICYmIChpbnRlclRpbWVXS04uZXJyb3JzPy5wYXR0ZXJuKTtcIlxuICAgICAgICAgICAgICAgICAgICBjbGFzcz1cImlubGluZS1pY29uIGVycm9yXCI+XG4gICAgICAgICAgICAgICAgICAgIDxzcGFuPk9vcHMhIE9ubHkgbnVtZXJpY2FsIHZhbHVlcywgXCIuXCIgYW5kIFwiOlwiIGFyZSBhbGxvd2VkLjwvc3Bhbj4hXG4gICAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvZGl2PlxuICAgIDwvZm9vdGVyPlxuPC9mb3JtPlxuIiwiPGFwcC1wYXlyb2xsLXRpbWU+PC9hcHAtcGF5cm9sbC10aW1lPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNPZ0I7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUM4QjtJQUMxQjtJQUFNO0lBQTREOzs7Ozs7TUFTdEU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUM4QjtJQUMxQjtJQUFNO0lBQTREOzs7Ozs7TUFTdEU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUM4QjtJQUMxQjtJQUFNO0lBQTREOzs7Ozs7TUFTdEU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUM4QjtJQUMxQjtJQUFNO0lBQTREOzs7Ozs7TUFZdEU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUM4QjtJQUMxQjtJQUFNO0lBQTREOzs7Ozs7TUFSOUU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFnRDtNQUM1QztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlDO0lBQXNCO01BQy9EO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0I7SUFDcEI7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BRThFO1FBQUE7UUFBQTtNQUFBO01BRjlFO0lBQUE7Z0JBQUE7OztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBO0lBRWlLO0lBQ2pLO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHTztJQUNMOzs7O0lBTGlJO0lBRm5JLFNBRW1JLFVBRm5JO0lBQW1CO0lBRTJEO0lBRjlFLFVBQW1CLFdBRTJELFVBRjlFO0lBR007SUFBTixVQUFNLFVBQU47OztJQUhzSDtJQUNsSDtJQUNBO0lBRko7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO01BQXNIO01BQ2xIO01BQ0E7TUFGSjtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO0lBQUE7SUFBQTs7Ozs7TUFlQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQzhCO0lBQzFCO0lBQU07SUFBNEQ7Ozs7OztNQVI5RTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWlEO01BQzdDO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBeUM7SUFBdUI7TUFDaEU7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QjtJQUNwQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFFOEU7UUFBQTtRQUFBO01BQUE7TUFGOUU7SUFBQTtnQkFBQTs7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFFbUs7SUFDbks7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUdPO0lBQ0w7Ozs7SUFMbUk7SUFGckksU0FFcUksVUFGckk7SUFBbUI7SUFFMkQ7SUFGOUUsVUFBbUIsV0FFMkQsVUFGOUU7SUFHTTtJQUFOLFVBQU0sVUFBTjs7O0lBSHdIO0lBQ3BIO0lBQ0E7SUFGSjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7TUFBd0g7TUFDcEg7TUFDQTtNQUZKO01BQUE7TUFBQTtNQUFBO01BQUE7TUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBOzs7Ozs7SUEvRGhCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtJQUFBO2dCQUFBO2dCQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFBOEQ7TUFDMUQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFpRDtNQUM3QztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1DO01BQy9CO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBeUM7SUFBbUI7TUFDNUQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QjtJQUNwQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQzhFO1FBQUE7UUFBQTtNQUFBO01BRDlFO0lBQUE7Z0JBQUE7OztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBO0lBQzJKO0lBQzNKO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHTztJQUNMO0lBQ0o7TUFDTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1DO01BQy9CO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBeUM7SUFBaUI7TUFDMUQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QjtJQUNwQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQzRFO1FBQUE7UUFBQTtNQUFBO01BRDVFO0lBQUE7Z0JBQUE7OztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBO0lBQ3dKO0lBQ3hKO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFHTztJQUNMO0lBQ0o7TUFDTjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1DO01BQy9CO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBeUM7SUFBVTtNQUNuRDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdCO0lBQ3BCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFDc0U7UUFBQTtRQUFBO01BQUE7TUFEdEU7SUFBQTtnQkFBQTs7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFDMEk7SUFDMUk7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUdPO0lBQ0w7SUFDSjtNQUNOO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBbUM7TUFDL0I7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF5QztJQUFtQjtNQUM1RDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXdCO0lBQ3BCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFDOEU7UUFBQTtRQUFBO01BQUE7TUFEOUU7SUFBQTtnQkFBQTs7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2dCQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTs7TUFBQTs7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7O01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7Z0JBQUE7SUFDcUo7SUFDcko7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUdPO0lBQ0w7SUFDSjtJQUNEO01BQ1Q7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFpRDtJQUM3QztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBV007SUFDTjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBV007SUFDRDtJQUNOOzs7O0lBbkVzSTtJQUQ3SCxVQUM2SCxVQUQ3SDtJQUFtQjtJQUMyRDtJQUQ5RSxVQUFtQixXQUMyRCxVQUQ5RTtJQUVNO0lBQU4sVUFBTSxVQUFOO0lBVTBIO0lBRDFILFVBQzBILFVBRDFIO0lBQW1CO0lBQ3lEO0lBRDVFLFVBQW1CLFdBQ3lELFVBRDVFO0lBRU07SUFBTixVQUFNLFVBQU47SUFVNEc7SUFENUcsVUFDNEcsVUFENUc7SUFBbUI7SUFDbUQ7SUFEdEUsVUFBbUIsV0FDbUQsVUFEdEU7SUFFTTtJQUFOLFVBQU0sVUFBTjtJQVV1SDtJQUR2SCxVQUN1SCxVQUR2SDtJQUFtQjtJQUMyRDtJQUQ5RSxVQUFtQixXQUMyRCxVQUQ5RTtJQUVNO0lBQU4sVUFBTSxVQUFOO0lBUTJCO0lBQW5DLFVBQW1DLFVBQW5DO0lBWW1DO0lBQW5DLFdBQW1DLFVBQW5DOzs7SUE1RFI7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxTQUFBLHFFQUFBO0lBSzhJO0lBQzFIO0lBREo7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFVBQThILFVBQzFILFVBREosVUFBQSw0RUFBQTtJQVdnSDtJQUM1RztJQURKO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxVQUFnSCxXQUM1RyxXQURKLFdBQUEsNEVBQUE7SUFXb0g7SUFDaEg7SUFESjtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsVUFBb0gsV0FDaEgsV0FESixXQUFBLDRFQUFBO0lBV29IO0lBQ2hIO0lBREo7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFVBQW9ILFdBQ2hILFdBREosV0FBQSw0RUFBQTs7Ozs7SUN0Q2hCO2dCQUFBOzs7SUFBQTs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/payroll-time/payroll-time.component.ngfactory.ts